import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import * as React from 'react';
import { connect } from 'react-redux';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { getDataDependency, getDisplayName } from 'gandi.react-helpers';
import { logging } from '../redux/logging';
/**
 * Inject a logger in a component.
 *
 * Usage:
 *
 * @withLogger('myNamespace')
 * class MyAwesomeComponent extends Component {
 *   static propTypes = {
 *     logger: PropTypes.object.isRequired,
 *   }
 *
 *   componentWillMount() {
 *     this.props.logger.info('blah');
 *   }
 * }
 */
export var withLogger = function withLogger(namespace) {
  return function (WrappedComponent) {
    if (typeof namespace !== 'string') {
      throw new Error('withLogger expects first parameter to be a string. ' + "(".concat(_typeof(namespace), " given)\n") + "Usage withLogger('namespace')(YourComponent)");
    }
    function WithLogger(props) {
      var enhancedProps = _objectSpread(_objectSpread({}, props), {}, {
        logger: logging(props.dispatch, namespace)
      });
      return /*#__PURE__*/React.createElement(WrappedComponent, enhancedProps);
    }
    WithLogger.displayName = "WithLogger(".concat(getDisplayName(WrappedComponent), ")");
    WithLogger.WrappedComponent = WrappedComponent;
    var HoistedComponent = hoistNonReactStatic(WithLogger, WrappedComponent);
    HoistedComponent.preFetch = function preFetch(props) {
      var loggerProps = {
        logger: logging(props.dispatch, namespace)
      };

      // Call child preFetch if any
      var wrappedPreFetch = getDataDependency(WrappedComponent, 'preFetch');
      if (wrappedPreFetch) {
        return wrappedPreFetch(_objectSpread(_objectSpread({}, props), loggerProps));
      }
      return null;
    };
    return connect()(WithLogger);
  };
};